<template>
  <div class="topheader">
    <!-- 修改密码 -->
    <el-dialog
      title="更改密码"
      width="500px"
      :visible.sync="pwdShow"
      :before-close="beforeClose"
    >
      <el-form
        ref="pwdForm"
        :model="pwdParams"
        :rules="pwdRules"
        :label-width="formLabelWidth"
      >
        <el-form-item label="新密码:" prop="password">
          <el-input
            type="password"
            v-model="pwdParams.password"
            show-password
          ></el-input>
          <pwdMeter :password="pwdParams.password" />
        </el-form-item>
        <el-form-item label="确认新密码:" prop="confirmPwd">
          <el-input
            type="password"
            v-model="pwdParams.confirmPwd"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="beforeClose">取 消</el-button>
        <el-button type="primary" @click="confirmEditDic">确 定</el-button>
      </span>
    </el-dialog>
    <i
      :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
      style="font-size: 20px"
      @click="toShow"
    ></i>
    <el-dropdown trigger="click" class="index-dropdown">
      <div class="info">
        <div class="index-span">
          <div class="name">
            {{ loginUser.username == "admin" ? "管理员" : loginUser.username }}
          </div>
          <i class="el-icon-caret-bottom el-icon--right"></i>
        </div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item icon="el-icon-edit-outline" @click.native="changePwd"
          >修改密码</el-dropdown-item
        >
        <el-dropdown-item icon="el-icon-switch-button" @click.native="quit"
          >退出登陆</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import pwdMeter from "../../components/pwdMeter.vue";
export default {
  data() {
    const confirmPwdValid = (r, v, cb) => {
      if (v !== this.pwdParams.password) {
        cb("确认密码与新密码不一致！");
      } else {
        cb();
      }
    };
    return {
      loginUser: "",
      loading: true,
      pwdShow: false,
      pwdParams: {
        id: "",
        password: "",
        confirmPwd: "",
      },
      pwdRules: {
        password: { required: true, message: "请输入新密码", trigger: "blur" },
        confirmPwd: [
          { required: true, message: "请输入原密码", trigger: "blur" },
          {
            validator: confirmPwdValid,
            trigger: "blur",
          },
        ],
      },
      formLabelWidth: "100px",
    };
  },
  components: { pwdMeter },
  props: ["isCollapse"],
  mounted() {
    this.loginUser = JSON.parse(localStorage.getItem("loginUser"));
  },
  methods: {
    changePwd() {
      this.pwdShow = true;
    },
    quit() {
      this.$confirm("确定要退出登录?", "提示", {
        type: "warning",
      }).then(() => {
        localStorage.removeItem("ch_token");
        localStorage.removeItem("loginUser");
        this.$router.replace("/login");
      });
    },
    toShow() {
      this.$emit("toShow");
    },
    beforeClose() {
      this.pwdShow = false;
      Object.assign(this.$data.pwdParams, this.$options.data().pwdParams);
    },
    confirmEditDic() {
      this.$refs.pwdForm.validate(async (valid) => {
        if (valid) {
          this.pwdParams.id = this.loginUser.id;
          let res = await this.$api.changePwd(this.pwdParams);
          if (res.code == 0) {
            this.$notify.success({
              title: "修改成功",
              message: "即将重新登录",
            });
            this.pwdShow = false;
            setTimeout(() => {
              localStorage.removeItem("ch_token");
              localStorage.removeItem("loginUser");
              this.$router.push("/login");
            }, 2000);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.topheader {
  height: 64px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;

  > i:hover {
    cursor: pointer;
    color: #409eff;
  }
}
.el-header {
  color: #545c64;
  height: 64px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.index-bg {
  width: calc(100% - 160px);
  float: left;
}
.header-bg {
  position: absolute;
  left: 0;
  width: 100vw;
  height: 64px;
  z-index: 10;
}

.header-word {
  z-index: 12;
  vertical-align: top;
  float: left;
  width: calc(70% - 80px);
  height: 64px;
}
.header-word img {
  margin-top: 24px;
  max-width: 704px;
  float: left;
  max-height: 21px;
}

.header-logo {
  z-index: 11;
  vertical-align: top;
  float: left;
  width: 30%;
  height: 64px;
  margin-right: 40px;
}
.header-logo img {
  margin-top: 7px;
  max-width: 300px;
  float: left;
  max-height: 52px;
}
.topnav-jump {
  line-height: 30px;
  height: 30px;
  padding: 0 10px;
  border-radius: 15px;
  background-color: rgba(2, 69, 140, 0.6);
  color: #000;
  font-size: 14px;
  cursor: pointer;
  z-index: 14;
  position: absolute;
  right: 200px;
  top: 50%;
  transform: translateY(-50%);
}
.topnav-jump:hover {
  background-color: rgb(2, 69, 140);
}
.header-icon {
  width: 64px;
  height: 64px;
  float: left;
  margin-top: 10px;
}
.index-span {
  color: #000;
  cursor: pointer;
  display: flex;
  align-items: center;

  .name {
    max-width: 70px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.index-dropdown {
  height: 50px;
  line-height: 50px;
  padding: 0 10px 0 30px;
  margin: 10px 0;
  z-index: 14;
}
.header-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  float: right;
  margin-top: 5px;
  margin-right: 10px;
}
</style>
